import {
  DialogActions,
  DialogContent,
  Divider,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { IoWarningOutline } from "react-icons/io5";
import { useTranslation } from "react-i18next";
import ConfirmAndCancelButtons from "../../../../components/buttons/ConfirmAndCancelButtons";

const DELETE_KEYWORD = "delete";

export default function DeleteUserDialogContent({
  confirmText,
  onChange,
  onCancel,
  onConfirm,
  isLoading,
}) {
  const { t } = useTranslation();

  return (
    <>
      <Stack p={3} justifyContent="center" alignItems="center">
        <IoWarningOutline color="orange" size={120} />
      </Stack>

      <DialogContent sx={{ pt: 0 }}>
        <Stack spacing={2.5} alignItems="center">
          <Typography variant="h6" fontWeight={600} textAlign="center">
            {t("DeleteUserTitle")}
          </Typography>
          <Typography variant="body2" color="text.secondary" textAlign="center">
            {t("DeleteUserConfirmationMessage")}
          </Typography>
          <Typography variant="body2" color="text.secondary" textAlign="center">
            {t("DeleteUserTypeHint_Before")} <strong>{DELETE_KEYWORD}</strong>{" "}
            {t("DeleteUserTypeHint_After")}
          </Typography>
          <TextField
            value={confirmText}
            onChange={onChange}
            placeholder={DELETE_KEYWORD}
            size="small"
            fullWidth
            autoComplete="off"
            error={confirmText.length > 0 && confirmText !== DELETE_KEYWORD}
            inputProps={{ "data-testid": "user.delete-dialog.confirm-input" }}
          />
        </Stack>
      </DialogContent>

      <Divider />
      <DialogActions sx={{ p: 2 }}>
        <ConfirmAndCancelButtons
          confirmTitle={t("Delete")}
          cancelTitle={t("Cancel")}
          onCancel={onCancel}
          onConfirm={onConfirm}
          isConfirmLoading={isLoading}
          confirmButtonProps={{
            disabled: confirmText !== DELETE_KEYWORD,
            color: "error",
          }}
          testId="user.delete-dialog"
        />
      </DialogActions>
    </>
  );
}
